import {ApolloCache} from '@apollo/client';

export const createProjectCacheEvictor = (rootFieldName: string) => {
	return (cache: ApolloCache<any>): void => {
		cache.evict({fieldName: rootFieldName});
		cache.gc();
	};
};
